var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcNewChat = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m5.176 16.389 10.79-10.791L19.4 9.03 8.61 19.82l-3.12.93a1 1 0 0 1-1.244-1.243zM16.687 4.878l1.161-1.161a2.427 2.427 0 1 1 3.433 3.433L20.12 8.31z"
})));
export default SvgIcNewChat;